import { atom, useAtom } from "jotai";

const createdUserAtom = atom({});

/** Meant to add a recently created user to a `<SelectInput />` list */
export const useCreatedUserStore = () => useAtom(createdUserAtom);
